import { createContext, useContext, useEffect, useLayoutEffect, useMemo, useReducer } from 'react';
import { SECTIONS, ACTIONS, APP_ROUTES, RESULTS_SECTIONS } from '../utils/globalUtils.js'; // Adjust the path as needed
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './auth-context.jsx';

const GeneralContext = createContext();

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.setActiveSection:

            return {
                ...state,
                activeSection: action.payload
            };
        case ACTIONS.setTeaserCities: 

            return {
                ...state,
                teaserCities: action.payload
            }
        case ACTIONS.setResultsSection: 

            return {
                ...state,
                resultsSection: action.payload
            }
        case ACTIONS.setSubscribeAlertShow: 

            return {
                ...state,
                subscribeAlertShow: action.payload
            }
        case ACTIONS.setTriggerVariableDetails: 

            return {
                ...state,
                triggerVariableDetails: action.payload
            }
        case ACTIONS.setWantsMatrixReference: 

            return {
                ...state,
                wantsMatrixReference: action.payload
            }
        case ACTIONS.setClientAndSupplierLocation: 

            return {
                ...state,
                clientLocation: action.payload.clientLocation,
                supplierLocation: action.payload.supplierLocation
            }
        case ACTIONS.setShowColumn: 

            return {
                ...state,
                showColumn: action.payload
            }
        default:
            return state;
    }
}

export const GeneralProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {
        activeSection: SECTIONS.login,
        teaserCities: [],
        resultsSection: RESULTS_SECTIONS.map,
        subscribeAlertShow: false,
        triggerVariableDetails: null,
        wantsMatrixReference: [],
        clientLocation: null,
        supplierLocation: null,
        showColumn: "",
    });
    const { user, updateUser, activeVerificationCode } = useAuth()

    function showSubscribeModal() {
        dispatch({ type: ACTIONS.setSubscribeAlertShow, payload: true })
    }
    
    function triggerDetailsSection(variable = null) {
        dispatch({ type: ACTIONS.setTriggerVariableDetails, payload: variable })
    }
    
    function updateWantsMatrixReference (data) {
        dispatch({ type: ACTIONS.setWantsMatrixReference, payload: data })

    }

    const navigate = useNavigate()
    const currentUrl = useLocation()
    const searchParams = new URLSearchParams(currentUrl.search);
    const token = searchParams.get("teaserReportToken");

    const referralCode = useMemo(() => {
        const searchParams = new URLSearchParams(currentUrl.search)
        const referralCode = searchParams.get("referralCode") ?? ""
        return referralCode
    }, [currentUrl])

    useLayoutEffect(() => {
        if (token) {
            dispatch({ type: ACTIONS.setShowColumn, payload: "preset" })
        } 
    }, [])
    
    useLayoutEffect(() => {
        if (user && !user?.isFinish && currentUrl.pathname !== APP_ROUTES.report && currentUrl.pathname !== APP_ROUTES.results) {
            navigate(APP_ROUTES.report)
        }
        
    }, [user, currentUrl])
    
    useLayoutEffect(() => {
        if (user?.isFinish && currentUrl.pathname === APP_ROUTES.report) {
            navigate(APP_ROUTES.login)
        }

        if (currentUrl.pathname === APP_ROUTES.login && user?.isFinish) {
            dispatch({ type: ACTIONS.setShowColumn, payload: "" })
            updateUser(null)
        }
    }, [currentUrl])
    
    useEffect(() => {
        if (!activeVerificationCode && !token && !referralCode) navigate(APP_ROUTES.login)
    }, [])

    if (currentUrl.pathname === APP_ROUTES.login && state.activeSection !== SECTIONS.login) dispatch({ type: ACTIONS.setActiveSection, payload: SECTIONS.login })

    if (currentUrl.pathname === APP_ROUTES.auth && state.activeSection !== SECTIONS.auth) dispatch({ type: ACTIONS.setActiveSection, payload: SECTIONS.auth })

    if (currentUrl.pathname === APP_ROUTES.report && state.activeSection !== SECTIONS.report) dispatch({ type: ACTIONS.setActiveSection, payload: SECTIONS.report })

    const value = {
        state,
        dispatch,
        showSubscribeModal,
        triggerDetailsSection,
        updateWantsMatrixReference
    }
        
    return (
        <GeneralContext.Provider value={value}>
            {children}
        </GeneralContext.Provider>
    );
};

export const useGeneralStates = () => useContext(GeneralContext);